import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import router from '../router'

// axios.defaults.baseURL = 'http://localhost:8000'
axios.defaults.baseURL = 'https://api.chatacuity.com/installation'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    autoJoinStepEnabled: true,  // this is only ever manually changed IN-CODE

    installStep: 1,
    installCompleted: false,

    installProgress: 0,
    installProgressMax: 100,

    installCode: null,

    tokenExchangeDataLoaded: false,
    tokenExchangeData: null,

    dashboardEmailDataLoaded: false,
    dashboardEmailData: null,

    workspaceChannelsDataLoaded: false,
    workspaceChannelsData: null,

    // submittedChannels: false,
    joinTeamChannelsDataLoaded: false,
    joinTeamChannelsData: null,

    numericTeamId: null,
    slackTeamId: null,

    errorResponse: null
  },
  mutations: {
    installStep(state, stepNumber) {
      state.installStep = stepNumber
    },
    installCompleted(state, isCompleted) {
      state.installCompleted = isCompleted
    },
    installProgress(state, progressPct) {
      state.installProgress = progressPct
    },
    installCode(state, code) {
      state.installCode = code
      console.log('committed install code: ' + state.installCode)
    },

    tokenExchangeData(state, data) {
      state.tokenExchangeData = data
    },
    tokenExchangeDataLoaded(state, isLoaded) {
      state.tokenExchangeDataLoaded = isLoaded
    },

    dashboardEmailData(state, data) {
      state.dashboardEmailData = data
    },
    dashboardEmailDataLoaded(state, isLoaded) {
      state.dashboardEmailDataLoaded = isLoaded
    },

    workspaceChannelsData(state, data) {
      state.workspaceChannelsData = data
    },
    workspaceChannelsDataLoaded(state, isLoaded) {
      state.workspaceChannelsDataLoaded = isLoaded
    },

    joinTeamChannelsData(state, data) {
      state.joinTeamChannelsData = data
    },
    joinTeamChannelsDataLoaded(state, isLoaded) {
      state.joinTeamChannelsDataLoaded = isLoaded
    },

    numericTeamId(state, id) {
      state.numericTeamId = id
    },
    slackTeamId(state, id) {
      state.slackTeamId = id
    },

    errorResponse(state, resp) {
      state.errorResponse = resp
    }
  },

  getters: {

  },

  actions: {
    submitDashboardLoginEmail(context, email) {
      context.commit('dashboardEmailDataLoaded', false)

      axios.post('/new-dashboard-login', {email: email, team_id: context.state.numericTeamId})
      .then(response => {
        console.log(response)
        context.commit('dashboardEmailData', response)
        context.commit('dashboardEmailDataLoaded', true)


        context.commit('installCompleted', true)
        context.commit('installStep', 4)
        router.push({ name: 'step4' })

      }).catch((error) => {
        console.log(error.response)

        context.commit('errorResponse', error.response)
      })
    },
    submitInstallCode(context, installCode) {
      context.commit('tokenExchangeDataLoaded', false)

      axios.get('/install?code=' + installCode).then(response => {
        console.log(response)
        context.commit('tokenExchangeData', response)
        context.commit('tokenExchangeDataLoaded', true)

        context.commit('numericTeamId', response.data.data.team_id)
        context.commit('slackTeamId', response.data.data.team_slack_id)

        context.commit('installStep', 2)

        router.push({ name: 'step2' })
        
      }).catch((error) => {
        console.log(error.response)
        context.commit('installStep', 0)

        context.commit('errorResponse', error.response)
        router.push({ name: 'error' })
      })
    },
    fetchWorkspaceChannels(context) {
      context.commit('workspaceChannelsDataLoaded', false)
      axios.get('/fetch-channels?team=' + context.state.slackTeamId).then(response => {
        console.log(response)
        context.commit('workspaceChannelsData', response)
        context.commit('workspaceChannelsDataLoaded', true)
        
      }).catch((error) => {
        console.log(error.response)
        context.commit('installStep', 0)

        context.commit('errorResponse', error.response)
        router.push({ name: 'error' })
      })
    },

    submitWatchedChannels(context, channels) {
      // don't care about the names, just the IDs
      let channelIds = channels.map(c => c.slack_id)

      context.commit('joinTeamChannelsDataLoaded', false)

      axios.post('/join-team-channels', {
        team_slack_id: context.state.slackTeamId, 
        channels: channelIds})
      .then(response => {
        console.log(response)
        context.commit('joinTeamChannelsData', response)
        context.commit('joinTeamChannelsDataLoaded', true)

        if(context.state.autoJoinStepEnabled) {
          router.push({ name: 'step2part3' })
        } else {
          router.push({ name: 'step3' })
        }
        

      }).catch((error) => {
        console.log(error.response)
        context.commit('installStep', 0)
        context.commit('errorResponse', error.response)
      })
    },

    setAutoJoinNewChannels(context, shouldAutoJoin) {
      
      axios.post('/autojoin-new-channels', {
        team_slack_id: context.state.slackTeamId, 
        autojoin: shouldAutoJoin})
      .then(response => {
        console.log(response)
        router.push({ name: 'step3' })

      }).catch((error) => {
        console.log(error.response)
        // this in particualr isn't SO bad as to abort the whole installation process
        // context.commit('installStep', 0)
        // context.commit('errorResponse', error.response)
        router.push({ name: 'step3' })
      })
    }

  },
  modules: {
  }
})
